import { type FunctionComponent, lazy, Suspense } from "react";

import { Spinner } from "@app/components/spinners/spinner";

const ImporterCuratePageProjectList = lazy(() => {
  return new Promise<{ default: FunctionComponent }>((resolve, reject) => {
    import("curate/lib")
      .then((lib) => {
        resolve({
          default: () => <lib.default.PageProjectList />,
        });
      })
      .catch(reject);
  });
});

export const LazyCuratePageProjectList = () => {
  return (
    <Suspense fallback={<Spinner height={"100vh"} />}>
      <ImporterCuratePageProjectList />
    </Suspense>
  );
};
